import type { AmrapStop } from "@heraion/shared";
import type { TFn } from "./i18nTypes";

// #355: the words of an AMRAP stop rule, one place for the editor's chips
// and the simulator's AMRAP lines, so the two never name it differently.

/** The short form: a chip, a line in a list. */
export const amrapStopShort = (t: TFn, stop: AmrapStop): string =>
  stop.kind === "rir"
    ? t("program.amrapStop.rir", { n: stop.rir, defaultValue: "RIR {{n}}" })
    : t("program.amrapStop.technical", { defaultValue: "Form breaks" });

/** The whole sentence, for the ear and for a line with room. */
export const amrapStopSentence = (t: TFn, stop: AmrapStop): string =>
  stop.kind === "rir"
    ? t("program.amrapStop.a11yRir", {
        count: stop.rir,
        defaultValue: "Stop with {{count}} reps in reserve",
      })
    : t("program.amrapStop.a11yTechnical", {
        defaultValue: "Stop at the first rep that breaks form",
      });
